import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-by-contact-us',
  templateUrl: './by-contact-us.component.html',
})
export class ByContactUsComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
